<template>

  <div class="contactUsWrap"
       @dragover="handleFileDragOver"
       @dragenter="handleFileDragEnter"
       @dragleave="handleFileDragLeave"
       @drop="handleFileDrop"
  >
    <div class="contactUsInnerWrap">
      <h1 class="title">CONTACT US</h1>
      <p class="contactUsComment">
        써니팩토리는 다양한 프로그램 개발 경험과 창의적 구성, 편의성을 기반으로<br/>
        고객의 Needs를 정확하게 이해, 파악하고 설계에서 개발, 테스트, 완료까지 성공적인 프로젝트를 수행하고 있습니다.
        <br/><br/>
        <strong>써니팩토리만의 아이덴티티로 특별한 서비스를 경험해 보세요.</strong>
      </p>

      <question-box/>

      <conformation/>

      <specificity/>

      <client-box/>

      <div class="clientRequestSubmitButtonWrap">
        <button
          class="clientRequestSubmitButton"
          @click="clientRequestSubmit">의뢰하기
        </button>
      </div>
    </div>
    <full-loading
      v-show="loading"
      :comment="'의뢰내용을 전송하고 있습니다...'"
    />
    <div class="mobileComment">
      <p>모바일에서는 지원되지 않습니다. <br/>PC버전에서 의뢰하여주세요.</p>
    </div>
  </div>
</template>

<script>
  import QuestionBox from "./ContactUs/QuestionBox";
  import Conformation from "./ContactUs/Conformation";
  import Specificity from "./ContactUs/Specificity";
  import ClientBox from "./ContactUs/ClientBox";
  import FullLoading from "@/components/menu/layouts/FullLoading";


  import { mapGetters , mapState , mapActions , mapMutations } from 'vuex'


  export default {
    components: {
      FullLoading,
      ClientBox,
      Specificity,
      Conformation,
      QuestionBox
    },
    name: "ContactUs",
    created() {

    },
    data () {
      return {
        loading : false ,
      }
    },
    methods: {
      ...mapActions('contactUsStore' , ['API__POST__CLIENT__REQUEST' , 'API__POST__SLACK__MESSAGE']) ,
      clientRequestSubmit() {
        const {
          selectedConformations,
          selectedSpecificity,
          content,
          information,
          attachments,
          conformations
        } = this.$store.state.contactUsStore;

        //const {businessConditions , email , name , phoneNumber , position} = information ;

        const CONFORMATION_CHECK = (selectedConformations != null && selectedConformations.length > 0)
        const SPECIFICITY_CHECK = selectedSpecificity !== null;
        const CONTENT_CHECK = content !== null && content !== '';
        const INFORMATION_CHECK =
          Object.keys(information).filter(
            n => {
              if(n === 'businessConditions' || n === 'position')
                return false;
              else
                return (information[n] === null || information[n] === '')
            }).length === 0;


        if(!CONFORMATION_CHECK){
          this.$notie.alert(2, '프로젝트 형태를 선택해주세요.', 3);
          return null;
        }

        if(!SPECIFICITY_CHECK){
          this.$notie.alert(2, '프로젝트 성격을 선택해주세요.', 3);
          return null;
        }

        if(!INFORMATION_CHECK) {
          this.$notie.alert(2, '의뢰인 정보를 확인해주세요.', 3);
          return null;
        }

        if(!CONTENT_CHECK){
          this.$notie.alert(2, '의뢰 내용을 작성해주세요.', 3);
          return null;
        }

        const maxSize  = 50 * 1024 * 1024;
        let fileSize = 0;

        attachments.forEach((n) => {
          fileSize += n.size;
        });

        if(fileSize > maxSize){
          this.$notie.alert(2, '파일 전체 최대 첨부 용량은 50MB입니다.', 3);
          return null;
        }


        this.loading = true;

        const {businessConditions , email , name , phoneNumber , position} = information;
        const selectedConformationNames = conformations.filter( (n , i) => {
          return selectedConformations.includes(n.num)
        }).map(x => x.name).join(',');
        this.API__POST__CLIENT__REQUEST({
          name : name,
          businessConditions : businessConditions,
          position : position,
          phoneNumber : phoneNumber,
          email : email,
          content :content,
          specificity : selectedSpecificity ,
          conformation : selectedConformationNames ,
          uploadFiles : attachments,
        }).then( (response) => {
          if(response){
            this.API__POST__SLACK__MESSAGE({
              name : name,
              position : position,
              specificity : selectedSpecificity ,
              conformation : selectedConformationNames ,
            }).then( (res) => {
                this.loading = false;
                this.$notie.alert(1, '전송 되었습니다. 확인 후 연락드리겠습니다.', 3);
            }).catch( err => {
              this.loading = false;
              this.$notie.alert(1, '전송중 에러 , 에러가 지속될 시 이메일로 연락바랍니다.', 3);
            })
          }
          else{
            this.loading = false;
            this.$notie.alert(1, '전송중 에러 , 에러가 지속될 시 이메일로 연락바랍니다.', 3);
          }

        }).catch( err => {
          this.loading = false;
          this.$notie.alert(1, '전송중 에러 , 에러가 지속될 시 이메일로 연락바랍니다.', 3);
        })


      },
      handleFileDragOver(ev) {
        ev.preventDefault();
        ev.stopPropagation();
      },
      handleFileDragEnter(ev) {
        ev.preventDefault();
        ev.stopPropagation();
      },
      handleFileDragLeave(ev) {
        ev.preventDefault();
        ev.stopPropagation();
      },
      handleFileDrop(ev) {
        ev.preventDefault();
        ev.stopPropagation();
      }
    }
  }
</script>

<style scoped lang="scss">
  @import "@/styles/ContactUs.scss";

  .clientRequestSubmitButtonWrap {
    display: flex;
    justify-content: center;
    align-items: center;
    .clientRequestSubmitButton {
      width: 451px;
      height: 70px;
      background-color: #1a2d39;
      color: #fff;
      font-size: 1.5rem;
      line-height: 70px;
      margin: 3rem 0;
      cursor: pointer;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/menu/ContactUs.vue